import useUrlHelper from "../shared/urlHelper";
import {
  ConferenceEnvironment,
  useConferenceEnvironment,
  useConferenceEnvironmentNotUndefined,
} from "./ConferenceEnvironment";
import { AssetPlayer } from "./AssetPlayer";
import { Asset } from "../model/Asset";
import { GlobalErrorBoundary } from "./common/GlobalErrorBoundary";
import { CastPlayer } from "../shared/useCastPlayer";
import { useCallback } from "react";
import { AssetEnvironment } from "./AssetEnvironment";

interface ConferencePlayerProps {
  assets: Asset[] | undefined;
  imageSize: string | undefined;
  castPlayer: CastPlayer;
}

export function ConferencePlayer(props: ConferencePlayerProps) {
  return (
    <ConferenceEnvironment>
      <ConferencePlayerComponent {...props} />
    </ConferenceEnvironment>
  );
}

function ConferencePlayerComponent({
  assets,
  imageSize,
  castPlayer,
}: ConferencePlayerProps) {
  const conferenceEnv = useConferenceEnvironment();
  const { posterImage } = useUrlHelper();

  if (conferenceEnv && assets && assets.length > 1) {
    const backgroundAsset = assets[conferenceEnv.conferenceState.lastBigIndex];
    const backgroundImageUrl =
      conferenceEnv.conferenceState.lastBigIndex > -1 &&
      backgroundAsset.image_id
        ? posterImage(backgroundAsset.image_id, imageSize)
        : undefined;
    return (
      <div
        className="sdtv-conference"
        data-open={conferenceEnv.conferenceState.isOpen}
      >
        {conferenceEnv.conferenceState.isOpen && (
          <div
            className="sdtv-conference-backdrop"
            onClick={conferenceEnv.toggleConference}
          >
            <img
              className="sdtv-conference-background"
              src={backgroundImageUrl}
            />
          </div>
        )}
        <div className="sdtv-conference-assets">
          {conferenceEnv.conferenceState.showControls ? (
            <div
              className="sdtv-conference-button"
              onClick={conferenceEnv.toggleConference}
            >
              Konferenz
            </div>
          ) : null}
          <div
            className="sdtv-conference-assets-wrapper"
            data-amount={assets.length}
          >
            {assets.map((asset, index) => {
              return (
                <AssetEnvironment
                  key={`conf-asset-${index}`}
                  assetId={asset.id}
                  conferenceIndex={index}
                >
                  <ConferencePlayerAsset
                    asset={asset}
                    index={index}
                    castPlayer={castPlayer}
                    imageSize={imageSize}
                  />
                </AssetEnvironment>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function ConferencePlayerAsset({
  asset,
  index,
  castPlayer,
  imageSize,
}: {
  asset: Asset;
  index: number;
  castPlayer: CastPlayer;
  imageSize: string | undefined;
}) {
  const { setConferenceState } = useConferenceEnvironmentNotUndefined();

  const clickHandler = useCallback(() => {
    setConferenceState((oldState) => {
      return {
        ...oldState,
        lastBigIndex: oldState.bigIndex,
        bigIndex: index,
        isOpen: false,
      };
    });
  }, [setConferenceState, index]);
  if (asset.videos || asset.livestream) {
    return (
      <div onClick={clickHandler}>
        <GlobalErrorBoundary key={asset.id}>
          <AssetPlayer
            key={index}
            asset={asset}
            // web using default size (1920x1080) for now
            imageSize={imageSize}
            conferenceIndex={index}
            castPlayer={castPlayer}
          />
        </GlobalErrorBoundary>
      </div>
    );
  }
  return <></>;
}
